<template>
  <div :class="{login:$route.fullPath=='/login'}" id="app">
    <router-view></router-view>
  
  </div>
</template>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.login{
  background-image:url('./assets/n2n_login_bg.png');
  height:100vh;
  overflow-x: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.el-select-dropdown__list{
   font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.error-message-one{
    font-family: 'Avenir', Helvetica, Arial, sans-serif !important;
}
</style>

<script>
import {getNoiseDays} from './api'
import {mapGetters} from 'vuex';

export default {
  name: 'app',
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  mounted: function(){
  },
  watch:{
    getLanguage:function(lang){
        this.$switch(lang);
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?9f70a832